type GameStatus = "loading" | "ready" | "error";

export function setGameStatus(state: GameStatus, message: string): void {
  const status = document.querySelector<HTMLElement>("#game-status");
  if (!status) return;
  status.dataset.state = state;
  status.textContent = message;
}
